import actionTypes from './formViewer.actionTypes';
import { FormViewerActionTakenDisplays, TalentFormFormTypes } from './formViewer.constants';
import { getAnswerCount, getUnansweredCount } from '../Common/Services/utilities';
import moment from 'moment';


const initialState = {
  companyId: '',
  employeeId: '',
  isLoading: false,
  isSaving: false,
  isPublicForm: false,
  unansweredCount: 0,
  allVisibleQuestionsCount: 0,
  formInstance: {
    answers: "",
    formTypeId: 0,
    foreignId: "",
    optOutReason: ''
  },
  isFormModified: false,
  isFormCancelRequested: false,
  isFormNotAvailable: false,
  isSessionExpiring: false,
  useSurveysLabels: false,
  formInstanceActionTakenDisplay: FormViewerActionTakenDisplays.NoDisplay,
  lastAutoSave: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_LAUNCHED_FORM_BEGIN: return fetchLaunchedFormBegin(state, action);
    case actionTypes.FETCH_LAUNCHED_FORM_SUCCESS: return fetchLaunchedFormSuccess(state, action);
    case actionTypes.FETCH_LAUNCHED_FORM_FAILURE: return fetchLaunchedFormFailure(state);

    case actionTypes.SAVE_DRAFT_LAUNCHED_FORM_BEGIN:
    case actionTypes.COMPLETE_LAUNCHED_FORM_BEGIN: return saveLaunchedFormBegin(state);
    case actionTypes.SAVE_DRAFT_LAUNCHED_FORM_SUCCESS:
    case actionTypes.COMPLETE_LAUNCHED_FORM_SUCCESS: return saveLaunchedFormSuccess(state, action);
    case actionTypes.SAVE_DRAFT_LAUNCHED_FORM_FAILURE:
    case actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE: return saveLaunchedFormFailure(state);

    case actionTypes.UPDATE_LAUNCHED_FORM_UNANSWERED_COUNT: return updateFormUnansweredCount(state, action);
    case actionTypes.RESET_LAUNCHED_FORM_STATE: return resetState(state);
    case actionTypes.SET_LAUNCHED_FORM_MODIFIED: return setFormModified(state, action);
    case actionTypes.LAUNCHED_FORM_CANCEL_REQUESTED: return formInstanceCancelRequested(state);
    case actionTypes.LAUNCHED_FORM_CANCEL_CANCELLED: return formInstanceCancelCancelled(state);
    case actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE_NOT_AVAILABLE: return completeLaunchedFormFailureNotAvailable(state);
    case actionTypes.SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY: return setFormActionTakenDisplay(state, action);

    case actionTypes.SET_SESSION_TIMEOUT_EXPIRING: return setSessionTimeoutExpiring(state);
    case actionTypes.CLEAR_SESSION_TIMEOUT_EXPIRING: return clearSessionTimeoutExpiring(state);

    default:
      return state;
  }
}

const fetchLaunchedFormBegin = (state, { payload }) => {
  return {
    ...state,
    companyId: payload.companyId,
    employeeId: payload.employeeId,
    isLoading: true,
    isFormModified: false,
    isFormCancelRequested: false,
    isFormNotAvailable: false,
    useSurveysLabels: false,
    formInstanceActionTakenDisplay: FormViewerActionTakenDisplays.NoDisplay,
  };
};

const fetchLaunchedFormSuccess = (state, action) => {
  let formInstance = action.data;
  formInstance.optOutReason = ''; // clear the reason!
  let unansweredCount = getUnansweredCount(formInstance);
  let formInstanceAlreadyDeclined = (formInstance.statusDescription === 'Declined');
  let useSurveysLabels = formInstance.formTypeId === TalentFormFormTypes.Surveys;

  return {
    ...state,
    isLoading: false,
    isPublicForm: formInstance.isPublicForm,
    companyId: formInstance.companyId,
    formInstance: formInstance,
    useSurveysLabels: useSurveysLabels,
    unansweredCount: unansweredCount,
    isFormNotAvailable: formInstanceAlreadyDeclined,
  };
};

const fetchLaunchedFormFailure = state => {
  return {
    ...state,
    isLoading: false
  };
};

const saveLaunchedFormBegin = state => {
  return {
    ...state,
    isSaving: true
  };
};

const saveLaunchedFormSuccess = (state, action) => {
  let time = moment();
  let lastSavedTime = state.lastAutoSave
    ? (moment(time).isAfter(state.lastAutoSave) ? time : state.lastAutoSave)
    : time;

  return {
    ...state,
    lastAutoSave: lastSavedTime,
    isSaving: false,
    isFormModified: false,
    isFormCancelRequested: false,
    isFormNotAvailable: false,
    formInstance: { ...action.data }
  };
};

const saveLaunchedFormFailure = state => {
  return {
    ...state,
    isSaving: false
  };
};

const updateFormUnansweredCount = (state, action) => {
  let unansweredCount =  action.data;

  return {
    ...state,
    isFormCancelRequested: false,
    isFormNotAvailable: false,
    unansweredCount: unansweredCount
  };
};

const setFormModified = (state, action) => {
  let formInstance = state.formInstance;
  formInstance.answers = action.data.answers;
  let allVisibleQuestionsCount = action.data.allVisibleQuestionsCount;

  formInstance.answerCount = getAnswerCount(JSON.parse(formInstance.answers));
  let unansweredCount = allVisibleQuestionsCount - formInstance.answerCount;

  return {
    ...state,
    isFormModified: true,
    isFormNotAvailable: false,
    allVisibleQuestionsCount: allVisibleQuestionsCount,
    formInstance: formInstance,
    unansweredCount: unansweredCount,
  };
};

const formInstanceCancelRequested = (state) => {
  return {
    ...state,
    isFormCancelRequested: true,
    isFormDeclineRequested: false,
    isFormNotAvailable: false
  };
};

const formInstanceCancelCancelled = (state) => {
  return {
    ...state,
    isFormCancelRequested: false,
  };
};

const completeLaunchedFormFailureNotAvailable = (state) => {
  return {
    ...state,
    isFormNotAvailable: true
  };
};

const setFormActionTakenDisplay = (state, action) => {
  let templateName = state.formInstance.templateName;
  return {
    ...state,
    formInstanceActionTakenDisplay: action.data,
    formInstance: {
      ...initialState.formInstance,
      templateName: templateName
    },
  };
};

const setSessionTimeoutExpiring = (state) => {
  return {
    ...state,
    isSessionExpiring: true,
  };
};

const clearSessionTimeoutExpiring = (state) => {
  return {
    ...state,
    isSessionExpiring: false,
  };
};

const resetState = (state) => {
  let newState = {...initialState};
  newState.formInstance.templateName = (state && state.formInstance && state.formInstance.templateName) ? state.formInstance.templateName : '';
  
  return {
    ...newState
  };
};

